// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__32jvv","obliqueLineWrap":"membershipbadge_obliqueLineWrap__gl28U","obliqueLine":"membershipbadge_obliqueLine__I0c1h"};